<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style>
html, body {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: #f2f2f4;
}

.clear{zoom:1;}
.clear:after{content:'';display:block;clear:both;}

.table-no-data-color {
  background-color: #fff8f8 !important;
}

.table-total-row {
  background-color: #a9bef5 !important;
  color: #fff !important;
  font-weight: bold;
}

.table-total-row-all {
    background-color: #8db685 !important;
    color: #fff !important;
    font-weight: bold;
}

.table-row-dark-zzz {
  background-color: #f5f5f5 !important;
  color: #000 !important;
  font: 12px;
  /*font-weight: bold;*/
}

.table-row-light-zzz {
  background-color: #fff !important;
  color: #000 !important;
  /*font-weight: bold;*/
}

.table-total-row .old {
  color: #dfeaeb;
}

.old {
  color: #64a8db;
}

/* 选中行取消高亮 */
.el-table__body tr.hover-row > td.el-table__cell {
  background: none !important;
}
.el-table tbody tr:hover td {
    /*pointer-events: none;*/
    background-color: unset!important;
}


.el-table__body tr.hover-row {
    background: none !important;
}

/* 修改el-table样式 */
.el-table .cell, .el-table--border .el-table__cell:first-child .cell {
    padding-left: 6px!important;
    padding-right: 6px!important;
}

.el-table .el-table__cell {
    padding-top: 3px!important;
    padding-bottom: 3px!important;
}





</style>
